class DeliveryTime extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.update();
  }

  static get observedAttributes() {
    return ["data-available", "data-delivery", "data-message"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (["data-available", "data-delivery", "data-message"].includes(name)) {
      this.update();
    }
  }

  getDate(dayNumber) {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const date = new Date();
    date.setDate(date.getDate() + dayNumber);
    return `${date.getDate()} ${months[date.getMonth()]}`;
  }

  update() {
    const isAvailable = this.dataset.available === "true";
    this.shadowRoot.innerHTML = "";

    if (!isAvailable) {
      this.classList.add("hide");
      return;
    }

    const delivery = this.dataset.delivery;
    const msg = this.dataset.message || "Get it by [startdate] - [enddate].";
    const parts = delivery.split(",");

    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
      const deliveryTime = parseInt(parts[0], 10);
      const deliveryGap = parseInt(parts[1], 10);
      const startDay = Math.max(deliveryTime - deliveryGap, 1);

      const startDate = this.getDate(startDay);
      const endDate = this.getDate(deliveryTime);
      const finalTime = msg.replace("[startdate]", startDate).replace("[enddate]", endDate);

      this.shadowRoot.textContent = finalTime;
    } else {
      this.shadowRoot.textContent = delivery;
    }
  }
}

customElements.define("delivery-time", DeliveryTime);